import { findMedicoByName } from '../../services/medico';

const linhaEndereco = (logradouro, bairro, cidade, uf) => {
  const partes = [logradouro, bairro].filter(Boolean).join(' - ');
  const cidadeUf = [cidade, uf].filter(Boolean).join('/');
  if (partes && cidadeUf) return `${partes} — ${cidadeUf}`;
  return partes || cidadeUf || '';
};

const emitenteDaReceita = receita => ({
  nome: receita?.nomeMedico || '',
  crm: receita?.crm || '',
  uf: '',
  endereco: '',
  telefone: '',
  cidade: '',
  ufEmitente: '',
});

/** Cadastro do médico (GET /medicos/nome) para o quadro do emitente. */
export const mapMedicoCadastroToEmitente = medico => {
  if (!medico) return null;

  const uf = medico.ESTADOMED || '';

  return {
    nome: medico.NOMEMED || '',
    crm: medico.CRMMED || '',
    uf,
    endereco: linhaEndereco(
      medico.ENDMED,
      medico.BAIRROMED,
      medico.CIDADEMED,
      uf
    ),
    telefone: medico.FONECOMMED || medico.CELULARMED || '',
    cidade: medico.CIDADEMED || '',
    ufEmitente: uf,
  };
};

/** Emitente da receita controlada: cadastro do médico da receita, por código. */
export async function resolveEmitenteMedico({ receita }) {
  if (receita?.nomeMedico && receita?.codMedico) {
    try {
      const lista = await findMedicoByName({ nome: receita.nomeMedico });
      const encontrado = Array.isArray(lista)
        ? lista.find(
            m => String(m.CODMEDICO) === String(receita.codMedico)
          )
        : null;
      if (encontrado) {
        return mapMedicoCadastroToEmitente(encontrado);
      }
    } catch {
      // sem cadastro: nome e CRM já estão na receita
    }
  }

  return emitenteDaReceita(receita);
}
